var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-h6 blue-grey--text text--darken-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }